import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Modal as MuiModal, IconButton, Icon } from "@mui/material";
import OptionMenu from "common/components/OptionMenu";
const style = (transparent, padding, overflow) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: transparent ? "transparent" : "#171717",
  border: transparent ? "none" : "2px solid #000",
  boxShadow: transparent ? "none" : 24,
  borderRadius: 3,
  p: padding,
  maxHeight: "90vh",
  overflow: transparent ? "hidden" : overflow ? overflow : "auto",
});

export default function Modal({
  button,
  glow = false,
  hideClose,
  children,
  closeColor = "error",
  padding = 5,
  width = 500,
  forceOpen = false,
  onOpen = () => {},
  onClose = () => {},
  menu = false,
  transparent,
  overflow,
  boxStyle = {},
  ...rest
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    onOpen();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    onClose();
  };
  React.useEffect(() => setOpen(forceOpen), [forceOpen]);
  return (
    <div>
      {button ? React.createElement(button, { onClick: handleOpen }) : null}
      <MuiModal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal"
        aria-describedby="modal"
        {...rest}
      >
        <Box
          className={glow ? "glowborder" : ""}
          sx={{
            ...style(transparent, padding, overflow),
            width,
            ...boxStyle,
            // ...(overflow ? { overflow } : {}),
          }}
        >
          {!!menu ? (
            <OptionMenu
              sx={{
                position: "absolute",
                right: "50px",
                top: "10px",
                zIndex: 2000,
              }}
              icon="more_vert"
              options={menu}
            />
          ) : null}

          {!hideClose ? (
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: "10px",
                top: "10px",
                zIndex: 2000,
                color: closeColor || "init",
              }}
              color={"error"}
            >
              <Icon sx={{ color: closeColor || "init" }} color="error">
                close
              </Icon>
            </IconButton>
          ) : null}
          {children({ handleClose })}
        </Box>
      </MuiModal>
    </div>
  );
}
